import React from 'react';
import { Container, Row, Col, Badge, Button } from 'react-bootstrap';
import './../../assets/css/TourePricingDetails.css';

const TourePricingDetails = ({ packages }) => {
  const badgeColors = [
    "danger",
    "success",
    "secondary",
    "info",
    "primary",
    "warning",
    "dark"
  ];
  return (
    <section className="tour-details-section">
      <Container>
        <Row className="g-4">
          {/* Left Section */}
          <Col lg={12}>
            <section className="tour-left">
              <div className="d-flex flex-wrap gap-2 mb-3">

                {packages?.category_name?.map((category, index) => (
                  <Badge
                    key={index}
                    bg={badgeColors[index % badgeColors.length]}
                    style={{
                      color: "#fff",
                      padding: "0.5rem 0.75rem",
                      borderRadius: "0.5rem",
                      fontSize: "0.85rem",
                    }}
                  >
                    {category}
                  </Badge>
                ))}
              </div>


              <h1 className="tour-title" style={{
                fontSize: "30px"
              }}> {packages?.name}</h1>
              <div className="tour-meta mb-3 text-muted"
                style={{
                  fontSize: "16px"
                }}
              >
                <i className="bi bi-clock"></i> {Number(packages?.duration?.length) > 0 ? `${packages?.duration} Days ${packages?.duration - 1} Nights ` : `${packages?.itinerary?.length} Days ${packages?.itinerary?.length - 1} Nights `}
                {/* <i className="bi bi-geo-alt"></i> 3 Cities */}
              </div>
              <div className="mb-4 text-muted"
                style={{
                  fontSize: "18px"
                }}
              >
                {packages?.description}
              </div>

              {/* <a  className="text-line">View daywise tour itinerary</a> */}

              {/* Info Panel */}

            </section>
            {/* <section className="info-panel mt-2">
                <p className="fw-bold mb-4">Why choose Radhe Shyam World?</p>
                <Row className="text-center mb-4">
                  <Col xs={6} md={3} className="stat-box">
                    <strong>8,44,044+</strong>
                    <div className="small text-muted">Happy Guests</div>
                  </Col>
                  <Col xs={6} md={3} className="stat-box">
                    <strong>64,798+</strong>
                    <div className="small text-muted">Successful Tours</div>
                  </Col>
                  <Col xs={6} md={3} className="stat-box">
                    <strong>10+</strong>
                    <div className="small text-muted">Years of Experience</div>
                  </Col>
                  <Col xs={6} md={3} className="stat-box">
                    <strong>700+</strong>
                    <div className="small text-muted">Team Members</div>
                  </Col>
                </Row>
                <div className="small text-muted"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                >
                  Need help? Call our travel experts at <a href="tel:1800227979" className="text-line">1800 22 7979</a>
                </div>
              </section> */}
          </Col>

          {/* Right Section */}
          {/* <Col lg={4}> */}

          {/* <section className="pricing-panel">
              <div className="price">₹2,124 <span style={{fontSize:"15px"}}>/mo</span></div>
              <div className="small">
                <a href="#" className="text-line">Check eligibility</a>
              </div>
              <p className="text-muted mt-3 mb-1">
                Starts from <strong>₹63,000</strong>
              </p>
              <small className="text-muted">Per person on twin sharing</small>
              <Button variant="warning" className="btn-book mt-4">Dates & Prices</Button>
              <p className="mt-4 mb-1">
                Join from any city starting at <span className="highlight-text">₹44,000</span>
              </p>
              <div className="d-flex justify-content-center gap-4 mt-3 flex-wrap">
                <a href="#" className="action-link"><i className="bi bi-table"></i> Pricing Table</a>
                <a href="#" className="action-link"><i className="bi bi-heart"></i> Wishlist</a>
                <a href="#" className="action-link"><i className="bi bi-share"></i> Share</a>
              </div>
            </section> */}
          {/* </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default TourePricingDetails;
